import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { of, Observable } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { ErrorHandlingService } from '../../services/error-handling/error-handling.service';
import { SpinnerService } from '../../services/spinner/spinner.service';
import { HttpHeaderConstants } from '../../services/http-header.constant';
import { RabbitPublisherService } from '../rabbit/publisher.service'; // eslint-disable-line
import { AppInstanceAction } from '../../models/appcloud/app-instance-action.model';

@Injectable({
    providedIn: 'root',
})
export class ActionService {
    readonly #errorHandlingService = inject(ErrorHandlingService);
    readonly #http = inject(HttpClient);
    readonly #spinnerService = inject(SpinnerService);

    private ACTIONS_URL: string = environment.publicApiHost + '/appcloud/actions';

    /**
     * @deprecated
     * @see {@link RabbitPublisherService}
     */
    run(
        globalAppId: string,
        appInstanceId: number,
        body: any = null,
        additionalHeaders: any = {}
    ): Observable<AppInstanceAction> {
        this.#spinnerService.addProcess('ActionsService.run.' + appInstanceId, 'Kicking off your process...');
        const url = `${this.ACTIONS_URL}/apps/${globalAppId}/appinstances/${appInstanceId}`;

        const httpOptions = {
            headers: new HttpHeaders({ ...HttpHeaderConstants.defaultHeaders, ...additionalHeaders }),
        };

        if (body == null) {
            body = {};
        }

        return this.#http.post<AppInstanceAction>(url, body, httpOptions).pipe(
            catchError(error => {
                this.#errorHandlingService.handleHttpError(
                    error,
                    false,
                    'An error occurred while trying to run the app. Please try again later.'
                );
                return of<AppInstanceAction>();
            }),
            finalize(() => this.#spinnerService.completeProcess('ActionsService.run.' + appInstanceId))
        );
    }
}
